<template>
    <div class="cities-selector">
        <v-autocomplete
            v-model="selected"
            :items="items"
            :label="label"
            :loading="loading"
            :no-data-text="t('default::hint.start.typing')"
            :search-input.sync="search"
            cache-items
            dense
            flat
            hide-details
            item-text="name"
            item-value="id"
            outlined
            v-bind="$attrs"
            @change="triggerChange"
            @click:clear="$emit('clear')"
            v-on="$listeners"
        >
            <template v-for="(_, slot) of $scopedSlots" #[slot]="scope">
                <slot :name="slot" v-bind="scope"></slot>
            </template>
            <template #selection="{ item }">
                {{ item.name }}
            </template>
            <template #item="{ item }">
                <v-list-item-content>
                    <v-list-item-title v-text="item.name"></v-list-item-title>
                    <v-list-item-subtitle v-text="_.get(item.region, 'name')"></v-list-item-subtitle>
                </v-list-item-content>
            </template>
        </v-autocomplete>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            required: false,
            default: String,
        },
        current: {
            type: Object,
            required: false,
            default: () => {
                return null;
            },
        },
    },
    data() {
        return {
            loading: false,
            selectedValue: null,
            items: [],
            search: null,
        };
    },
    computed: {
        selected: {
            get() {
                if (this.selectedValue === null && this.current !== null && this.items.length === 0) {
                    return this.current.id;
                }
                return this.selectedValue;
            },
            set(val) {
                this.selectedValue = val;
            },
        },
    },
    watch: {
        search(val) {
            val && val !== this.select && this.doSearch(val);
        },
    },
    methods: {
        doSearch: _.debounce(function (val) {
            axios.get(route('api.geo.cities', { q: val, limit: 5 })).then((response) => {
                this.items = response.data.data;
            });
        }, 300),
        triggerChange() {
            this.$emit('change', this.selectedValue);
        },
    },
};
</script>
